var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-disclosure-dropdown',{attrs:{"items":_vm.dropdownItems,"icon":"ellipsis_v","category":"tertiary","placement":"right","no-caret":"","data-testid":"wiki-more-dropdown"}})
}
var staticRenderFns = []

export { render, staticRenderFns }